import React from 'react'
import {
  GeckoComponentPath,
  GeckoComponentPolygon,
  GeckoMarkupLayer,
  GeckoMarkupPrimitive,
} from 'types'

import { PrimitiveOutline3D } from './util/PrimitiveOutline3D'

/**
 * Renders all lines associated with markup layer, including polygons, lines, and rects.
 * @param markupLayer      Markup Layer to render
 * @constructor
 */
export const MarkupOutlines3D: React.FC<{
  markupLayer: GeckoMarkupLayer
}> = ({ markupLayer }) => {
  //----------------------------------------------------------------------------
  const { primitives, paths } = React.useMemo(() => {
    const polygons = markupLayer.data.polygonPrimitives
    const rects = markupLayer.data.rectPrimitives
    const lines = markupLayer.data.linePrimitives
    const paths: GeckoComponentPath[] = []
    const primitives: GeckoMarkupPrimitive[] = []
    primitives.push(...polygons)
    for (const polygon of polygons) {
      paths.push(polygon.path)
    }
    primitives.push(...rects)
    for (const rect of rects) {
      paths.push(GeckoComponentPolygon.CreateFromRect(rect.rect))
    }
    primitives.push(...lines)
    for (const line of lines) {
      paths.push(line.path)
    }
    return { primitives, paths }
  }, [markupLayer])
  return (
    <PrimitiveOutline3D
      markupLayer={markupLayer}
      primitives={primitives}
      paths={paths}
    />
  )
}
